<template>
  <div class="news">
    <!-- <div class="header">
      <div
        class="item"
        v-for="item in titleList"
        :key="item.id"
        :class="titleId == item.id ? 'active' : ''"
        @click="clickTab()"
      >
        <div>{{ item.title }}</div>
      </div>
    </div> -->

    <div class="body">
      <div class="left">
        <div class="list">
          <div class="item" v-for="item in newsList" :key="item.id">
            <div class="box" v-if="item.id == newsId">
              <div class="title">{{ item.title }}</div>
              <div class="flex">
                <div class="date">
                  <img :src="timer" alt="" />
                  <div>{{ item.date }}</div>
                </div>
                <div class="source">来源：{{ item.source }}</div>
              </div>
              <img class="logo" :src="item.logo" alt="" />
              <div class="text">{{ item.text }}</div>
            </div>
          </div>
        </div>
      </div>

      <DynamicRight></DynamicRight>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import DynamicRight from "../../../components/pc/Dynamic/DynamicRight.vue";

import newsdetails6 from "../../../assets/dynamic/newsdetails6.png";
import newsdetails7 from "../../../assets/dynamic/newsdetails7.png";
import newsdetails8 from "../../../assets/dynamic/newsdetails8.png";
import newsdetails9 from "../../../assets/dynamic/newsdetails9.png";
import newsdetails10 from "../../../assets/dynamic/newsdetails10.png";

import timer from "../../../assets/dynamic/timer.png";

import more from "../../../assets/dynamic/more.png";

export default {
  props: ["newsId"],
  setup() {
    return reactive({
      more: more,
      demoShow: false,
      titleId: 2,
      titleList: [
        {
          id: 1,
          title: "行业新闻",
        },
        {
          id: 2,
          title: "公司动态",
        },
      ],
      newsList: [
        {
          id: 0,
          title: "宝山区11个消防救援站WIFI6项目",
          text: "为了对消防员绿色上网行为进行更好的管理，上海畅月物业管理有限公司响应宝山消防站的号召，对宝山11个消防站点及保障大队室内、外区域的信号进行全面覆盖，配置独立无线控制器，支持WIFI6无线AP、终端Mac地址方式认证，访客通过有效（账号密码）管理方式进行认证接入。该项目可以连接消防站绿色上网终端，实现数据的融合，建立起高效的联动机制，从而进行有效的安全管理。为消防员提供一个安全、迅捷的智慧化上网环境。该项目通过市消防总队的验收，也得到了建设方的肯定。",
          logo: newsdetails10,
          date: "2021-05-31",
          source: "何伟安防",
        },
        {
          id: 1,
          title: "宝山八村高空抛物系统集成服务项目",
          text: "2019年11月，最高人民法院印发《关于依法妥善审理高空抛物、坠物案件的意见》，明确对于故意高空抛物者，根据具体情形按照以危险方法危害公共安全罪、故意伤害罪或故意杀人罪论处，打开社区高度重视高空抛物监控的需求重要性。最高人民法院研究室负责人在答记者问时指出，在法律适用上要明确区分高空抛物和坠物，高空抛物和坠物行为在主观恶性、社会危害性方面有很大不同，不可一概而论。宝山八村位于上海市宝山区海滨新村街道，是国家建设部示范小区。上海畅月物业管理有限公司积极响应政府关于“高空抛物”管理的号召，顺利为宝山八村小区搭建了智能高空抛物系统。智能高空抛物系统，根据对现场的检测，判断是否有人进行高空抛物，一旦检测到，即刻触发机制进行报警，报警信号传到相关管理人员手中，抛物检测视频自动进行存储。根据对宝山八村小区的现场环境勘测，每幢楼布置800万像素高空抛物摄像机。部署完成后可以分别通过客户端、后端NVR 来验证抛物检测是否触发。根据NVR设置事件相关联的存储计划，可以进行报警录像的查询和回放。每个抛物检测事件，都单独采用小视频的方式存储，方便管理人员是对抛物报警录像的查询和回放，不仅可以起到事后追溯的作用，还可以起到事前预警、事中控制的作用，确保小区居民的人身安全。",
          logo: newsdetails9,
          date: "2021-01-27",
          source: "何伟安防",
        },
        {
          id: 2,
          title: "中冶祥腾宝月花园小区地下车库自动识别道闸系统 ",
          text: "宝月花园小区地处宝山月浦镇，小区地址位于申浦路，小区道路的合理组织，休闲设施的精心安排，提供自然、舒适的居住环境。由于其地理位置的特殊性，小区车辆较多，地下车库业主偶有将车辆不停入地下车库，而停在路面车位，占用公共资源，给停车管理带来较大工作量。为配合月浦宝月花园的车辆现代化管理，给所有住户一个安全舒适的居住环境，上海畅月物业管理有限公司提供一套技术先进、性能完善的道闸系统，为月浦宝月花园小区地下车库出入口安装道闸系统。AI无人值守道闸系统是用来管理车辆通行的综合智能系统，可实现无人值守，车辆驶出驶入，车闸智能识别，省时省力，保障居民快捷、安全进出小区。",
          logo: newsdetails6,
          date: "2021-01-15",
          source: "何伟安防",
        },
        {
          id: 3,
          title: "香岛原墅小区智能安防系统建设",
          text: "2021年8月1号国家应急管理部公布的《高层民用建筑消防安全管理规定》禁止在高层民用建筑公共门厅、疏散走道、楼梯间、安全出口停放电动自行车或者为电动自行车充电。香岛原墅小区位于宝山区美丰路88弄，小区原有一套模拟闭路电视监控系统，但由于监控系统所使用的时间久远，导致室外同轴视频线路已无法维修、设备破损、画面不清晰，主要集中在主干道、进出口、地下车库、高空抛物、单元楼入口、电梯轿厢电瓶车监测等区域，电梯轿厢经常有电瓶车驶入，无法拍摄到驶入的业主，不能起到一个良好的预警和监督作用。此外，小区仍然存在多处监控盲点，经常导致业主财物受损，为了更好的保护业主财产及小区的安全，便于秩序人员对小区的治安管理，根据本小区业主实际反映的智能监控的需求，上海畅月物业管理有限公司对小区原有的监控系统进行改造。该项目2020年9月14日开工，在业委会、物业和施工各方人员的共同努力下，已完成了本项目各项建设任务。项目在施工中、不断深化技术方案，听取业主和物业的意见，严格按照施工要求认真施工，在项目施工中也已排除施工中的安全隐患，在整个项目施工中并无安全事故。项目制定了完善的施工计划，在减少扰民行为的重点基础上，55 天顺利完成了该项目合计299台高清监控的安装以及对原有系统的改造，目前项目全部施工、调试完成，经相关部门共同检测，验收合格。后续公司将提供2年的免费维保、认真做好各项售后服务工作，给顾客最优质的体验。",
          logo: newsdetails8,
          date: "2020-11-21",
          source: "何伟安防",
        },
        {
          id: 4,
          title: "惠阳苑竣工案例",
          text: "和谐社会，平安为先，经济发展，稳定为要，创建智能化平安小区工程是加快经济发展，保障人民群众安居乐业的重要载体。惠阳苑小区是上海市宝山区推动平安社区智能化管理系统重点示范工程。上海畅月物业管理有限公司在智能化平安小区的创建工作中，积极响应政府的号召，为惠阳苑小区搭建智能化管理系统。",
          logo: newsdetails7,
          date: "2013-11-28",
          source: "何伟安防",
        },
      ],
      timer: timer,
    });
  },
  components: {
    DynamicRight,
  },
  methods: {
    clickTab() {
      this.$router.back();
    },
  },
};
</script>

<style scoped>
.news {
  width: 1180px;
  margin: 80px auto 190px;
}

.header {
  display: flex;
  border-bottom: 1px solid #dce1e8;
}
.header .item {
  padding: 40px 0;
  margin-right: 50px;
  font-size: 30px;
  cursor: pointer;
}
.header .active {
  border-bottom: 5px solid #248efb;
  color: #248efb;
}

.body {
  display: flex;
  justify-content: space-between;
  margin-top: 60px;
}
.body .left {
  width: 780px;
}
.body .left .list .item .box .title {
  font-size: 20px;
  color: #333;
}
.body .left .list .item .box .flex {
  display: flex;
  align-items: center;
  margin-top: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #dce1e8;
}
.source {
  margin-left: 40px;
  font-size: 12px;
  color: #6F8398;
}
.body .left .list .item .box .flex .date {
  display: flex;
  align-items: center;
}
.body .left .list .item .box .date img {
  width: 18px;
  margin-right: 10px;
}
.body .left .list .item .box .date div {
  font-size: 12px;
  color: #6f8398;
}
.body .left .list .item .box .logo {
  width: 780px;
  margin-top: 40px;
}
.body .left .list .item .box .text {
  font-size: 14px;
  color: #3d3d3d;
  margin-top: 20px;
}

.body .right .experience .experience1 img,
.body .right .experience .experience2 img {
  width: 360px;
}
.body .right .experience .experience1 {
  position: relative;
  margin-bottom: 20px;
}
.body .right .experience .experience1 .content {
  position: absolute;
  top: 15%;
  left: 10%;
}
.body .right .experience .experience1 .content .title {
  font-size: 14px;
  color: #fff;
}
.body .right .experience .experience1 .content .text {
  color: #8ea3b9;
  margin-top: 5px;
  font-size: 10px;
}
.body .right .experience .experience1 .content .go {
  width: 64px;
  height: 18px;
  border: none;
  text-align: center;
  background-color: #248efb;
  color: #fff;
  font-size: 10px;
  margin-top: 15px;
  border-radius: 212px 212px 212px 212px;
  cursor: pointer;
}
</style>
